var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.275,
    height: 24.29,
    viewBox: "0 0 24.275 24.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "comment_1",
    "data-name": "comment 1",
    transform: "translate(-0.725 -0.71)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "comment_1_Background_Mask_",
    "data-name": "comment 1 (Background/Mask)",
    d: "M0,0H24V24H0Z",
    transform: "translate(1 1)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.883,6.137A8.625,8.625,0,1,0,1.048,12.746L.032,16.313a.75.75,0,0,0,.722.955.767.767,0,0,0,.206-.028l3.568-1.017a8.246,8.246,0,0,0,1.593.667,8.475,8.475,0,0,0,2.509.379A8.631,8.631,0,0,0,16.883,6.137Z",
    transform: "translate(0.725 0.71)",
    fill: "#d13c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M14.82,11.354A8.611,8.611,0,0,0,11.91,0,10.1,10.1,0,0,1,1.99,12.127,10,10,0,0,1,0,11.921a8.686,8.686,0,0,0,7.24,3.956,8.572,8.572,0,0,0,4.1-1.045l3.567,1.016a.767.767,0,0,0,.205.029.75.75,0,0,0,.721-.955h0Z",
    transform: "translate(7.364 7.351)",
    fill: "#d13c3c"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.3e297aa5e39d8b38acebc689781a673d.svg";
export { ForwardRef as ReactComponent };